import axios, { AxiosResponse } from "axios";
import { Polo } from "../types/acao";

const API_URL = process.env.REACT_APP_API_URL;

export async function fetchPolos(): Promise<Polo[]> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  const response: AxiosResponse<Polo[]> = await axios.get(`${API_URL}/polos`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const polos = response.data as Polo[];

  return polos;
}

export async function createPolo(
  nome: string,
  cidadeSede: string,
  cidades: string[],
): Promise<Polo> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  const response: AxiosResponse<Polo> = await axios.post(
    `${API_URL}/polos`,
    { nome, cidade_sede: cidadeSede, cidades },
    { headers: { Authorization: `Bearer ${token}` } },
  );

  return response.data;
}

export async function deletePolo(id: number): Promise<void> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  await axios.delete(`${API_URL}/polos/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function updatePolo(
  id: number,
  nome: string,
  cidadeSede: string,
  cidades: string[],
): Promise<void> {
  const token = sessionStorage.getItem("token");
  if (!token) throw new Error("Token não encontrado");

  await axios.put(
    `${API_URL}/polos/${id}`,
    { nome, cidade_sede: cidadeSede, cidades },
    { headers: { Authorization: `Bearer ${token}` } },
  );
}
